import { toSafeLowerString, toSafeString } from '@shared/utils';
import getInteractionEventId from '@/lib/threadInteractions/getInteractionEventId.js';

const toResolvedInteractionIdSet = (events = []) => {
  const resolvedIds = new Set();

  for (const item of Array.isArray(events) ? events : []) {
    const normalizedType = toSafeLowerString(item?.type);
    const itemId = toSafeString(item?.id);
    const interactionId = getInteractionEventId(item);

    if (normalizedType === 'interaction_response' && interactionId) {
      resolvedIds.add(interactionId);
    }

    if (normalizedType === 'approval' && interactionId && toSafeString(item?.decision)) {
      resolvedIds.add(interactionId);
    }

    if (normalizedType === 'interaction' && interactionId && item?.response && typeof item.response === 'object' && !Array.isArray(item.response)) {
      resolvedIds.add(interactionId);
    }

    // An outcome recorded on the interaction itself answers it too: the OAuth callback and a run's
    // eventUpdate write `outcome` in place rather than adding a response (the API's own open-card test).
    if (normalizedType === 'interaction' && interactionId && toSafeString(item?.outcome)) {
      resolvedIds.add(interactionId);
    }

    if (itemId.endsWith(':decision')) {
      resolvedIds.add(itemId.replace(/:decision$/, ''));
    }

    if (itemId.endsWith(':response')) {
      resolvedIds.add(itemId.replace(/:response$/, ''));
    }
  }

  return resolvedIds;
};

export default toResolvedInteractionIdSet;
